var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.99966 11.6712C7.38495 11.6712 6.08789 10.3741 6.08789 8.75942C6.08789 7.14472 7.38495 5.84766 8.99966 5.84766C10.6144 5.84766 11.9114 7.14472 11.9114 8.75942C11.9114 10.3741 10.6144 11.6712 8.99966 11.6712ZM8.99966 7.17119C8.12613 7.17119 7.41142 7.88589 7.41142 8.75942C7.41142 9.63295 8.12613 10.3477 8.99966 10.3477C9.87318 10.3477 10.5879 9.63295 10.5879 8.75942C10.5879 7.88589 9.87318 7.17119 8.99966 7.17119Z",
    fill: "#4B4AD5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.0011 17.284C8.44522 17.284 7.88934 17.0722 7.46581 16.6487L4.28934 13.4722C1.69522 10.8781 1.69522 6.64278 4.28934 4.04867C5.55993 2.77808 7.22757 2.08984 9.0011 2.08984C10.7746 2.08984 12.4423 2.77808 13.7129 4.04867C16.307 6.64278 16.307 10.8781 13.7129 13.4722L10.5364 16.6487C10.1129 17.0722 9.55699 17.284 9.0011 17.284ZM9.0011 3.41337C7.62463 3.41337 6.27463 3.94278 5.21581 4.97514C3.12463 7.06631 3.12463 10.4545 5.21581 12.5193L8.39228 15.6957C8.70993 16.0134 9.23934 16.0134 9.58346 15.6957L12.7599 12.5193C14.8511 10.4281 14.8511 7.03984 12.7599 4.97514C11.7276 3.94278 10.3776 3.41337 9.0011 3.41337Z",
    fill: "#4B4AD5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.91647c7ac517879aebed17a06c53afd8.svg";
export { ForwardRef as ReactComponent };